/**
 * @const SET_OPEN
 * @const SET_PROFILE_COMPLETE
 * @const SET_HAS_PARTNERSHIPS
 */
export const SET_OPEN = "Status.SetOpen";
export const SET_PROFILE_COMPLETE = "Status.SetProfileComplete";
export const SET_HAS_PARTNERSHIPS = "Status.SetHasPartnerships";
